export default "/images/vendor/@coreui/icons/svg/flag/cif-ki.svg?96592a256df297582cb87e78b267a1a2";